// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"e674d943","425":"22b8a313","453":"31cb93fd","474":"1a67ecc3","523":"1395e759","528":"45c11177","698":"5abcf4bc","710":"c258331c","728":"666c05f6","770":"ab061f17","834":"946e29f8","900":"f064bd6c"}[chunkId] + ".chunk.js";
};